import React, { ReactNode } from 'react'
import { Box } from '@mui/material'
import { SIDEBAR_WIDTH } from '../../constants/layout'

/**
 * Props for SidebarContainer
 */
export interface SidebarContainerProps {
  children: ReactNode
  className?: string
  dataTestId?: string
}

/**
 * SidebarContainer - Main wrapper for the sidebar
 *
 * Provides the sidebar structure with:
 * - Fixed width
 * - Dark background
 * - Border styling
 * - Shadow effect
 */
export const SidebarContainer: React.FC<SidebarContainerProps> = ({ children, className = '', dataTestId }) => {
  return (
    <Box
      className={className}
      data-testid={dataTestId}
      sx={{
        height: '100vh',
        width: `${SIDEBAR_WIDTH}px`,
        backgroundColor: '#222629', // Sidebar background from Figma
        borderRight: `1px solid rgba(120, 144, 156, 0.2)`, // Thunder grey 20%
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
      }}
    >
      {children}
    </Box>
  )
}
